import Vue from "vue";

export default {
    async initLocale(vue, http) {
        let response = await http.get('i-18-n/initLocale');
        let currentLang = response.data.currentLanguage;

        if (Object.keys(response.data.availableLocales).includes(this.current())) {
            currentLang = this.current();
        }

        vue.$emit('init-locale', response.data.availableLocales, currentLang);
        Vue.locales({[currentLang]: response.data.data});
        Vue.lang(currentLang);
        this.set(currentLang);
    },
    set(lang, callback) {
        localStorage.setItem('lang', lang);

        if (callback) {
            callback();
        }
    },
    current() {
        return localStorage.getItem('lang');
    },
}


// WEBPACK FOOTER //
// ./src/services/lang/index.js